import React, { useEffect, useCallback, useState} from 'react';
import {setExpandedProject} from 'actions/index.js';
import accounts from 'accounts/Accounts.js';
import SearchOptions from './SearchOptions.js';
import SequencesList from './SequencesList.js';
import {connect} from 'react-redux';
import SampleSearch from 'components/selector2/SampleSearch.js';

const Sequences = (props) => { 
    let [searchTerm, setSearchTerm] = useState('');
    let [filterMine, setFilterMine] = useState(accounts.isLoggedIn());
    let [favorited, setFavorited] = useState(false); 
    let [starred, setStarred] = useState(false); 
    let {setExpandedProject, expandedProject} = props;
    const onChange = useCallback((s) => {
        setSearchTerm(s);
    }, [setSearchTerm]);

    return (
        <div className="new-selector sequences">
          <div className="search-and-back"><SampleSearch onChange={onChange} hideFilter={true}/></div>
          {!expandedProject ?
           <SearchOptions
             favorited={favorited}
             starred={starred}
             setFavorited={setFavorited}
             setStarred={setStarred}
             setFilterMine={setFilterMine}
             filterMine={filterMine}/> : '' }
          <SequencesList
            expandedProject={expandedProject}
            setExpandedProject={setExpandedProject}
            sequencerEngine={props.sequencerEngine}
            favorited={favorited}
            starred={starred}
            searchTerm={searchTerm}
            filterMine={filterMine}/>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      expandedProject: state.selector.expandedProject
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setExpandedProject: p => dispatch(setExpandedProject(p))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sequences);
